import React, { useState, useContext } from "react";
import { ThemeProvider } from "@mui/styles";
import { StyledEngineProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import theme from "./ui/Theme";
import Header from "./ui/Header";
import Footer from "./ui/Footer";
import LandingPage from "./screens/LandingPage";
import About from "./screens/About";
import Contact from "./screens/Contact";
import Activities from "./screens/Activities";
import ResetPassword from "./screens/ResetPassword";
import Content from "../components/ui/PostContent";
import Projects from "./screens/Projects";
import ResearchPapers from "./screens/ResearchPapers";
import TechFlame from "./screens/TechFlame";
import Profile from "./screens/Profile";
import Events from "./screens/Events";
import Teams from "./screens/Teams";
import Login from "./screens/Login";
import Register from "./screens/Register";
import PasswordResetEmail from "./screens/ResetPasswordEmail";
import VerifyEmail from "./screens/VerifyEmail";
import UnauthorizePage from "./screens/Unauthorized";
import ChangePassword from "./screens/ChangePassword";

function App() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [value, setValue] = useState(0);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Header
            value={value}
            setValue={setValue}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
          />
          <ToastContainer />
          <Routes>
            <Route
              path="/"
              element={
                <LandingPage
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/activities"
              element={
                <Activities
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/projects"
              element={
                <Projects
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route path="/project/:id" element={Content} />
            <Route
              path="/researchpapers"
              element={
                <ResearchPapers
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route path="/researchpaper/:id" />
            <Route
              path="/events"
              element={
                <Events
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route path="/event/:id" />
            <Route path="/techflame" element={<TechFlame />} />
            <Route path="/techflame/:id" />
            <Route path="/teams" element={<Teams />} />
            <Route path="/team/:id" />
            <Route
              path="/about"
              element={
                <About
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/contact"
              element={
                <Contact
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/login"
              element={
                <Login
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/register"
              element={
                <Register
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/resetpassword"
              element={
                <ResetPassword
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
            <Route
              path="/users/password-reset-confirm/:uidb64/:token/"
              element={<ChangePassword />}
            />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route
              path="/password-reset-email"
              element={<PasswordResetEmail />}
            />
            <Route path="/unauthorized" element={<UnauthorizePage />} />
            <Route
              path="/profile"
              element={
                <Profile
                  setValue={setValue}
                  setSelectedIndex={setSelectedIndex}
                />
              }
            />
          </Routes>
          <Footer setValue={setValue} setSelectedIndex={setSelectedIndex} />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
